import {Findings} from '@github-ui/copilot-findings'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {PageLayout} from '@primer/react'
import {Suspense} from 'react'
import {usePullRequestBasePath} from '../stores/layout-selectors'

export const FindingsEntrypoint = () => (
  <PageLayout.Content as="div" padding="normal" width="full">
    <ErrorBoundary boundaryName="FindingsEntrypoint" fallback={null}>
      <Suspense fallback={null}>
        <FindingsContent />
      </Suspense>
    </ErrorBoundary>
  </PageLayout.Content>
)

const FindingsContent = () => {
  const basePath = usePullRequestBasePath()

  return <Findings pullRequestBasePath={basePath} />
}
